import { z } from 'zod';

export const videoRecordingSchema = z.object({
    createdAt: z.string(), // RFC3339
    filename: z.string(),
    isExpired: z.boolean(),
    url: z.string(),
});

export type VideoRecording = z.infer<typeof videoRecordingSchema>;

export const visioConnectStatisticsRoomSchema = z.object({
    id: z.number(),
    subject: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
    idArticle: z.number(),
    idUser: z.number(),
    user: z.object({
        id: z.number(),
        uri: z.string(),
        title: z.string(),
    }),
    stats: z.object({
        participantsNumber: z.number(),
        totalDurationSeconds: z.number(),
        visioSessionsNumber: z.number(),
    }),
});

export const visioConnectStatisticsSchema = z.object({
    rooms: z.object({
        totalItems: z.number(),
        member: z.array(visioConnectStatisticsRoomSchema),
    }),
    platform: z.object({
        sessionsNumber: z.number(),
        durationAverage: z.number(),
        durationMedian: z.number(),
        participantsNumber: z.number(),
    }),
});

export type VisioConnectRoom = z.infer<typeof visioConnectStatisticsRoomSchema>;
export type VisioConnectStatistics = z.infer<typeof visioConnectStatisticsSchema>;

const visioConnectStatisticsRoomSessionSchema = z.object({
    id: z.number(),
    room: z.string(),
    duration: z.number(),
    participantsNb: z.number(),
    startedAt: z.string(),
    endedAt: z.string(),
});

export const visioConnectStatisticsRoomSessionsSchema = z.object({
    totalItems: z.number(),
    member: z.array(visioConnectStatisticsRoomSessionSchema),
});

export type VisioConnectStatisticsRoomSession = z.infer<typeof visioConnectStatisticsRoomSessionSchema>;
export type VisioConnectStatisticsRoomSessions = z.infer<typeof visioConnectStatisticsRoomSessionsSchema>;
